module.exports = __webpack_public_path__ + "static/media/white-bubble-arrow.101be4ed.svg";